import { render, staticRenderFns } from "./OrderNotReady.vue?vue&type=template&id=5394639d&"
import script from "./OrderNotReady.vue?vue&type=script&lang=js&"
export * from "./OrderNotReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports